import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ExternalLink, Instagram, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { getPartnerSlug } from '../../data/partners';

const PartnerCard = ({ partner }) => {
  const to = `/partners/${getPartnerSlug(partner)}`;
  return (
    <Card
      className="group overflow-hidden border-none shadow-sm hover:shadow-lg transition-all duration-300 bg-white"
      data-testid={`partner-${partner.id}`}
    >
      <Link to={to} className="block relative h-24 overflow-hidden" data-testid={`partner-image-link-${partner.id}`}>
        <img
          src={partner.image}
          alt={partner.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute top-2 right-2 bg-white/90 text-[#2C2C2C] px-2 py-0.5 text-[9px] tracking-wider rounded">
          {partner.category}
        </div>
      </Link>
      <CardContent className="p-4">
        <Link to={to} data-testid={`partner-name-link-${partner.id}`}>
          <h3
            className="text-xl md:text-2xl text-[#2C2C2C] mb-1 group-hover:text-[#DE92A9] transition-colors leading-tight"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            {partner.name}
          </h3>
        </Link>
        <div className="flex items-center gap-1 text-[11px] text-[#8B7D6B] mb-2">
          <MapPin size={12} />
          <span>{partner.location}</span>
        </div>
        <p className="text-[#6B4E37] text-xs leading-relaxed mb-3 line-clamp-2">
          {partner.description}
        </p>
        <div className="flex items-center gap-3">
          <Link
            to={to}
            className="inline-flex items-center gap-1 text-[11px] tracking-[0.15em] font-semibold text-[#DE92A9] hover:text-[#C9758F] transition-colors"
            data-testid={`partner-profile-link-${partner.id}`}
          >
            VIEW PROFILE <ArrowRight size={12} />
          </Link>
          <span className="flex-1" />
          {partner.website && partner.website !== '#' && (
            <a href={partner.website} target="_blank" rel="noopener noreferrer" aria-label={`${partner.name} website`} className="text-[#A0978A] hover:text-[#DE92A9] transition-colors">
              <ExternalLink size={14} />
            </a>
          )}
          {partner.instagram && partner.instagram !== '#' && (
            <a href={partner.instagram} target="_blank" rel="noopener noreferrer" aria-label={`${partner.name} Instagram`} className="text-[#A0978A] hover:text-[#DE92A9] transition-colors">
              <Instagram size={14} />
            </a>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default PartnerCard;
